import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-onboarding-platform-6",
  "use": "icon-onboarding-platform-6-usage",
  "viewBox": "0 0 42 43",
  "content": "<symbol viewBox=\"0 0 42 43\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-onboarding-platform-6\">\n<circle cx=\"21\" cy=\"21.5\" r=\"20.5\" fill=\"#F2F2F2\" stroke=\"#E5E5E5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol